export type PersonaSnapshot = {
  orgId: string | null
  orgType: string | null
  role: string | null
}

let snapshot: PersonaSnapshot | null = null

export function setPersonaSnapshot(next: PersonaSnapshot | null): void {
  snapshot = next
}

export function getPersonaSnapshot(): PersonaSnapshot | null {
  return snapshot
}
